import firebase from '@/firebase';
import db from '@/db';

import { UPDATE_PROFILE, SET_SURVEY_ID,
         RESET_SURVEY_ID, SET_LEAD_ID,
         SET_CREATED_AT, SET_UPDATED_AT,
         RESET_STATE, GET_LEAD_FROM_EMAIL,
         PUSH_LEAD, RESET_LEAD_LIST } from './mutations';


const initialState = {
  profile: {
    email: "",
    firstName: "",
    lastName: "",
    company: "",
    roleAtCompany: "",
    priorities: [
      {name: "Suivre ma flotte", checked: false},
      {name: "Optimiser les trajets", checked: false},
      {name: "Récupérer des informations sur mes conducteurs", checked: false},
      {name: "Augmenter la performance des commerciaux", checked: false},
      {name: "Mettre à niveau l'écosystème technique", checked: false},
      {name: "Ne sais pas", checked: false}
    ],
    projectDeadline: "",
    surveysIds: [],
    meta: {
      created_at: new Date(),
      updated_at: firebase.firestore.FieldValue.serverTimestamp()
    },
  },

  activeSurvey: {id: null, status: ""}, // status in [started, missing_info, finished]
  list: [],
  docID: null
};

const state = Object.assign({}, initialState)

const getters = {
  profile: ({profile}) => profile,
  docID: ({docID}) => docID,
  list: ({list}) => list,
  activeSurveyId: ({activeSurveyId}) => activeSurveyId,
};

const mutations = {

  [UPDATE_PROFILE](state, info) {
    console.log("VueX info : ", info)
    state.profile.email = info.email;
    state.profile.firstName = info.firstName;
    state.profile.lastName = info.lastName;
    state.profile.company = info.company;
    state.profile.roleAtCompany = info.roleAtCompany;
    state.profile.priorities = info.priorities;
    state.profile.projectDeadline = info.projectDeadline;

    console.log("VueX state : ", state)
  },

  [SET_LEAD_ID](state, LeadID) {
    state.docID = LeadID;
  },

  [SET_CREATED_AT](state) {
    state.profile.meta.created_at = Date.now();
  },
  [SET_UPDATED_AT](state) {
    state.profile.meta.updated_at = firebase.firestore.FieldValue.serverTimestamp();
  },

  [SET_SURVEY_ID](state, SurveyID) {
    state.activeSurvey.id = SurveyID;
    state.activeSurvey.status = "started";
  },

  [PUSH_LEAD](state, lead) {
    state.list.push(lead);
  },

  [RESET_SURVEY_ID](state, SurveyID) {
    state.activeSurveyId = null;
  },

  [RESET_STATE](state) {
    let newState = initialState;
    state = Object.assign(state, newState);
  },

  [RESET_LEAD_LIST](state) {
    state.list = [];
  },
};

const actions = {

  async getOrCreateProfile({state, commit}) {

    var created = false;

    if (!state.profile.email) {
      throw new Error('An email is required to create the survey!');
    }

    const lead = await db.collection('leads')
                            .where("email", "==", state.profile.email)
                            .limit(1)
                            .get();



    if (lead.docs.length == 0 || !lead.docs[0].exists) {
      // the lead doesn't exist yet, we create it

      commit(SET_CREATED_AT);
      const newDoc = await db.collection('leads').add({
            ...state.profile,
          });

      commit(SET_LEAD_ID, newDoc.id);
      created = true;
    } else {

      // We set all fields we got from the DB and let the other by default
      for(var key in lead.docs[0].data()) {
          if(state.profile.hasOwnProperty(key)) {
            state.profile[key] = lead.docs[0].data()[key];
          }
      }
      commit(SET_LEAD_ID, lead.docs[0].id);
    }
    return created;
  },

  async saveProfile({state, commit}) {
    // Save the profile in Firestore
    commit(SET_UPDATED_AT);
    await db.collection('leads').doc(state.docID).update({
            ...state.profile
          });
  },

  async getLeadFromEmail({state, commit}, payload ) {

    // payload = {email: "john@okedito.com"}
    // Fetch and instantiate a given lead

    if (!payload.email) {
      throw new Error('An email is required to fetch the lead!');
    }
    await db.collection('leads')
      .where("email", "==", payload.email)
      // .orderBy("meta.created_at")
      .limit(1)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          // We set all fields we got from the DB and let the other by default
          for(var key in doc.data()) {
            if(state.profile.hasOwnProperty(key)) {
              state.profile[key] = doc.data()[key];
            }
          }
          commit(SET_LEAD_ID, doc.id);
        });
      });
  },

  async list({commit}) {
    commit(RESET_LEAD_LIST);

    db.collection('leads').onSnapshot(snapshot => {
      snapshot.docChanges().forEach(function(change) {
        if (change.type === "added") {
          commit(PUSH_LEAD, {
            id: change.doc.id,
            ...change.doc.data()
          });
        }
      });
    });
  },

  resetSurveyId(store) {
    store.activeSurveyId = null;
  }


};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/lead/index.js